import React, { useContext, useEffect } from 'react';
import AppHeader from '@/components/layout/header';
import AppFooter from '@/components/layout/footer';
import s from './styles.module.scss';
import AppNavbar from '@/components/layout/navbar';
import { useRouter } from 'next/router';
import { useAuth } from '@/infrastructure/context/auth-context';
import {
  BreadcrumbContext,
  IBreadcrumbContextType,
} from '@/infrastructure/context/breadcrumb-context';
import { Slide } from '@mui/material';
import { isMobile } from 'react-device-detect';
import AppPlayer from '@/components/player';
import classNames from 'classnames';
import { usePlayer } from '@/infrastructure/context/player-context';
import { useReadBookmarks } from '@/infrastructure/context/read-bookmarks-context';
import { useAudioBookmarks } from '@/infrastructure/context/audio-bookmarks-context';

interface IMainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<IMainLayoutProps> = (props) => {
  const { children } = props;
  const { loadAudioBookmarks } = useAudioBookmarks();
  const { loadReadBookmarks, loadLastRead } = useReadBookmarks();
  const { player } = usePlayer();

  const { breadcrumbs } = useContext(
    BreadcrumbContext
  ) as IBreadcrumbContextType;

  const { authUser } = useAuth();

  const footerClassNames = classNames(s['footer'], {
    [s['opened']]: player.opened,
  });

  const router = useRouter();
  let animationKey = `${router.pathname}`;
  if (router.query.slug) {
    animationKey += `-${router.query.slug}`;
  }

  useEffect(() => {
    const shouldLoadBookmarks =
      router.pathname === '/bookmarks' ||
      router.pathname === '/my-favorite' ||
      router.pathname === '/profile' ||
      router.pathname === '/playlist';

    if (!shouldLoadBookmarks) {
      return;
    }

    if (authUser) {
      (async () => {
        await loadAudioBookmarks(authUser);
        await loadReadBookmarks(authUser);
        await loadLastRead(authUser);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  return (
    <div className={s['layout']}>
      <AppNavbar />
      <AppHeader breadcrumbs={breadcrumbs} />
      <div className={s['content']}>{children}</div>
      <AppFooter className={footerClassNames} />
      <div className={s['mobile-player']}>
        <Slide in={player.opened} direction="up" mountOnEnter unmountOnExit>
          <div className={s['player']}>{isMobile && <AppPlayer />}</div>
        </Slide>
      </div>
    </div>
  );
};

export default MainLayout;
